import { EventLogs } from "@/components/features/matter/event-logs/EventLogs";
import { AppModal } from "@/components/ui";
import type { Matter, MatterSubItemType } from "@/lib/types";

interface MatterSubItemEventLogsModalProps {
  entityLabel: string;
  matter: Pick<Matter, "id">;
  onOpenChange: (open: boolean) => void;
  open: boolean;
  subItem: {
    id: string;
    type: MatterSubItemType;
  };
}

export const MatterSubItemEventLogsModal = ({
  entityLabel,
  matter,
  onOpenChange,
  open,
  subItem,
}: MatterSubItemEventLogsModalProps) => {
  return (
    <AppModal
      open={open}
      onOpenChange={onOpenChange}
      title={`Event log for ${entityLabel}`}
      size="2xl"
      bodyContained
    >
      <div className="flex h-[min(70vh,42rem)] min-h-0 flex-col p-4">
        <EventLogs matter={matter} subItem={subItem} bareLayout />
      </div>
    </AppModal>
  );
};
